import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React from "react";
import { useField } from "formik";
import { MyCheckBoxInputProps } from "../../../../../../templates/Interfaces";
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft';
import AlignHorizontalCenterIcon from '@mui/icons-material/AlignHorizontalCenter';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import OptionContainer from "./OptionContainer";

export const AlignSelector = (props: MyCheckBoxInputProps) => {
    const { label, name } = props;
    const [field, , { setValue }] = useField(name);

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
        setValue(newValue);
    };

    return (
        <OptionContainer>
            <Typography>{label}</Typography>
            <ToggleButtonGroup value={field.value || ''} exclusive onChange={handleAlignmentChange}>
                <ToggleButton value="left"><AlignHorizontalLeftIcon /></ToggleButton>
                <ToggleButton value="center"><AlignHorizontalCenterIcon /></ToggleButton>
                <ToggleButton value="right"><AlignHorizontalRightIcon /></ToggleButton>
            </ToggleButtonGroup>
        </OptionContainer>
    );
};

export default AlignSelector;